import React from 'react';
import 'twin.macro';
import { Tag } from '@teetsh/app/src/components/Tag';
import {
  getLabelText,
  referentialLabelParser,
} from '@teetsh/app/src/components/Bo/referentialLabelParser';

interface Props {
  label: string;
  className?: string;
}

const CATEGORY_PREFIX = '--- ';

export function isReferentialItemCategory(label: string) {
  return label.startsWith(CATEGORY_PREFIX);
}

export function SectionReferentialItemElement(props: Props) {
  const { label } = props;
  return (
    <div
      className={props.className}
      tw="bg-neutral-moderate text-sm px-4 py-1 font-semibold"
    >
      {label.replace('--- ', '')}
    </div>
  );
}

export function ReferentialItemElement(props: Props) {
  const { label, className } = props;

  if (isReferentialItemCategory(label)) {
    return (
      <SectionReferentialItemElement className={className} label={label} />
    );
  }

  // Optimization: If the label doesn't contain the marker, just render it as plain text.
  if (!label.includes('<<')) {
    return <span className={className}>{label}</span>;
  }

  const segments = referentialLabelParser(label);

  return (
    <>
      {segments.map((segment, idx) =>
        segment.type === 'tag' ? (
          <Tag
            color={segment.color} // Use the color provided by the parser
            key={idx}
            size="sm"
            tw="mr-2 align-middle shrink-0"
          >
            {segment.name}
          </Tag>
        ) : (
          <span key={idx} className={props.className} tw="align-middle mr-1">
            {segment.content}
          </span>
        ),
      )}
    </>
  );
}

export function getPureReferentialItemName(label: string) {
  if (isReferentialItemCategory(label)) {
    return label.replace('--- ', '');
  }

  if (!label.includes('<<')) {
    return label;
  }

  return getLabelText(label);
}
